import { createIcon, Path } from './index';

export const IconHeartPulse = createIcon({
  title: 'A heart with a pulse line',
  viewBox: '0 0 32 32',
  path: [
    <Path
      d="M27.2268 6.10669C26.5579 5.43546 25.763 4.90287 24.8879 4.53948C24.0127 4.17608 23.0744 3.98901 22.1268 3.98901C21.1792 3.98901 20.2409 4.17608 19.3657 4.53948C18.4905 4.90287 17.6957 5.43546 17.0268 6.10669L16.0001 7.14669L14.9734 6.10669C14.3045 5.43546 13.5097 4.90287 12.6345 4.53948C11.7594 4.17608 10.8211 3.98901 9.87345 3.98901C8.92583 3.98901 7.98753 4.17608 7.11235 4.53948C6.23718 4.90287 5.44235 5.43546 4.77345 6.10669C1.94678 8.93336 1.77345 13.7067 5.33345 17.3334L16.0001 28L26.6668 17.3334C30.2268 13.7067 30.0534 8.93336 27.2268 6.10669Z"
      fill="none"
      stroke="#35405F"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
    <Path
      d="M4.66699 16H12.667L13.3337 14.6666L16.0003 20.6666L18.667 11.3333L20.667 16H27.3337"
      fill="none"
      stroke="#35405F"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
  ],
});
